export default __webpack_public_path__ + "static/logos-f5921f72c9277e0c4b49a1d72b047c74.png";